import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const cls = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : '');
  return (
    <header className="site-header">
      <div className="wrap">
        <nav className="nav" aria-label="Primary">
          <Link to="/" className="brand" onClick={close}>
            <span className="brand__mark" aria-hidden>H</span>
            <span>
              <span className="brand__name">Haven Crest Health</span>
              <span className="brand__sub">Patient advocacy · Free</span>
            </span>
          </Link>
          <div className={`nav__links ${open ? 'open' : ''}`}>
            <NavLink to="/services" className={cls} onClick={close}>How it works</NavLink>
            <NavLink to="/care-navigators" className={cls} onClick={close}>Navigators</NavLink>
            <NavLink to="/about" className={cls} onClick={close}>About</NavLink>
            <Link to="/contact" className="btn btn--accent btn--sm" onClick={close}>
              Get an advocate <span className="arrow">→</span>
            </Link>
          </div>
          <button className="nav__toggle" aria-label="Menu" aria-expanded={open} onClick={() => setOpen(!open)}>
            {open ? '✕' : '☰'}
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
